export var allNotificationsEnabled = {
  unsubscribedFromAllEmails: true,
  unsubscribedFromAllPushes: true,
  adminSummary: false,
  challengeDigest: true,
  challengeReminder: true,
  emailDigestDeliveryDays: 'daily',
  challengeRequests: true,
  newMessages: true,
  prospectAccepted: true,
  challengeFeedback: true,
  discussionReplies: true,
  discussionComments: true,
  discussionMentions: true,
  challengeResponseComments: true,
  badgeEarned: true,
  rewardFulfilled: true,
  perksAvailable: true,
  challengesPush: true,
  referralsPush: true,
  rewardsPush: true,
  badgesPush: true,
  discussionsPush: true
};